<template>
  <div class="kutu">
    <router-link active-class="aktif" to="/panel" tag="a" class="IkonMenu">
      <svg id="Layer_1" enable-background="new 0 0 512.027 512.027" height="512" viewBox="0 0 512.027 512.027"
           width="512" xmlns="http://www.w3.org/2000/svg">
        <g>
          <path
            d="m81.518 276.026c.001-92.546 58.206-171.491 140.004-202.242-9.156-7.602-21.636-11.157-34.424-8.197-95.737 22.157-167.097 107.964-167.098 210.439-.001 119.646 96.355 216.002 216.001 216.001 10.426 0 20.676-.751 30.707-2.179-104.951-14.873-185.191-104.643-185.19-213.822z"
            fill="#000000" opacity="0.2"/>
          <path
            d="m236.002 512.027c-63.209 0-122.521-24.501-167.011-68.991-44.49-44.49-68.992-103.802-68.991-167.01 0-53.648 18.492-106.166 52.068-147.879 33.066-41.081 79.42-70.218 130.521-82.045 17.859-4.135 36.349.047 50.721 11.474 14.42 11.464 22.69 28.6 22.69 47.016v131.437c0 11.028 8.972 20 20 20h131.437c18.415 0 35.552 8.271 47.016 22.69 11.426 14.373 15.608 32.86 11.475 50.721-11.828 51.101-40.966 97.454-82.047 130.521-41.714 33.574-94.232 52.066-147.879 52.066zm-39.907-427.471c-1.492 0-2.996.17-4.486.515-89.264 20.66-151.608 99.183-151.609 190.955 0 52.524 20.341 101.792 57.275 138.726 36.935 36.935 86.202 57.276 138.727 57.275 91.771 0 170.294-62.344 190.955-151.608 1.367-5.911-.023-12.038-3.816-16.81-3.831-4.818-9.555-7.582-15.704-7.582h-131.437c-33.084 0-60-26.916-60-60v-131.436c0-6.149-2.764-11.874-7.582-15.704-3.568-2.837-7.896-4.331-12.323-4.331zm-8.996-18.97h.01z"
            fill="#FFFFFF"/>
          <path
            d="m450.588 216.027h-93.168c-33.867 0-61.42-27.553-61.42-61.42v-93.168c0-19.694 9.087-37.688 24.93-49.371 15.919-11.737 35.905-15.11 54.84-9.25 31.304 9.686 60.088 27.045 83.242 50.199 23.152 23.153 40.511 51.937 50.198 83.24 5.858 18.933 2.487 38.921-9.251 54.84-11.682 15.843-29.677 24.93-49.371 24.93zm-93.156-175.992c-4.543 0-8.983 1.44-12.764 4.228-5.509 4.062-8.668 10.322-8.668 17.176v93.168c0 11.811 9.609 21.42 21.42 21.42h93.168c6.854 0 13.114-3.16 17.177-8.669 4.117-5.584 5.296-12.61 3.232-19.276-7.772-25.116-21.697-48.208-40.271-66.781-18.573-18.574-41.666-32.499-66.781-40.271-2.153-.666-4.345-.995-6.513-.995z"
            fill="#ffc107"/>
        </g>
      </svg>
      <span>PANEL</span>
    </router-link>
    <a v-if="this.$store.getters.Yetki.yonetim>0" :class="$route.matched[0].path=='/yonetim'?'aktif':''" href="#"
       class="IkonMenu">

      <svg id="Layer_1" enable-background="new 0 0 512 512" height="512" viewBox="0 0 512 512" width="512"
           xmlns="http://www.w3.org/2000/svg">
        <g>
          <path
            d="m421 322.658c-8.977 4.681-19.175 7.342-30 7.342-35.898 0-65-29.102-65-65s29.102-65 65-65c10.825 0 21.023 2.661 30 7.342-20.794 10.842-35 32.585-35 57.658s14.206 46.816 35 57.658zm-341 69.383v-272.082c0-55.206 44.644-99.959 99.716-99.959h-60.716c-55.229 0-100 44.771-100 100v272c0 55.228 44.771 100 100 100h60.716c-55.072 0-99.716-44.753-99.716-99.959z"
            fill="#000000" opacity="0.2"/>
          <path
            d="m391 350c-46.869 0-85-38.131-85-85s38.131-85 85-85 85 38.131 85 85-38.131 85-85 85zm0-130c-24.813 0-45 20.187-45 45s20.187 45 45 45 45-20.187 45-45-20.187-45-45-45zm-159 272c0-11.046-8.954-20-20-20h-92.021c-44.1 0-79.979-35.879-79.979-79.979v-272.042c0-44.1 35.879-79.979 79.979-79.979h184.062c44.101 0 79.979 35.879 79.979 79.979 0 11.046 8.954 20 20 20s20-8.954 20-20c.001-66.156-53.822-119.979-119.999-119.979h-184.042c-66.156 0-119.979 53.823-119.979 119.979v272.041c0 66.157 53.823 119.98 119.979 119.98h92.021c11.046 0 20-8.954 20-20zm33-265c0-11.046-8.954-20-20-20h-98c-11.046 0-20 8.954-20 20s8.954 20 20 20h98c11.046 0 20-8.954 20-20zm0 153c0-11.046-8.954-20-20-20h-98c-11.046 0-20 8.954-20 20s8.954 20 20 20h98c11.046 0 20-8.954 20-20zm0-77c0-11.046-8.954-20-20-20h-98c-11.046 0-20 8.954-20 20s8.954 20 20 20h98c11.046 0 20-8.954 20-20z"
            fill="#FFFFFF"/>
          <path
            d="m492 512c-11.046 0-20-8.954-20-20 0-39.701-32.086-72-71.525-72h-16.949c-39.44 0-71.526 32.299-71.526 72 0 11.046-8.954 20-20 20s-20-8.954-20-20c0-61.757 50.03-112 111.525-112h16.949c61.496 0 111.526 50.243 111.526 112 0 11.046-8.954 20-20 20zm-187-362c0-11.046-8.954-20-20-20h-138c-11.046 0-20 8.954-20 20s8.954 20 20 20h138c11.046 0 20-8.954 20-20z"
            fill="#ffc107"/>
        </g>
      </svg>
      <span>YÖNETİM</span>
      <div class="AltMenu Yonetim">
        <router-link to="/yonetim/sirket">Şirket</router-link>
        <router-link to="/yonetim/site">Site</router-link>
        <router-link to="/yonetim/bina">Bina</router-link>
        <router-link to="/yonetim/mesken">Mesken Listesi</router-link>
        <router-link to="/yonetim/kisi">Kişi Listesi</router-link>
      </div>
    </a>
    <div v-if="!aienerji">
      <a v-if="this.$store.getters.Yetki.vezne>0" :class="$route.matched[0].path=='/vezne'?'aktif':''"
         href="#" class="IkonMenu">
        <svg id="Layer_1" enable-background="new 0 0 512 512" height="512" viewBox="0 0 512 512" width="512"
             xmlns="http://www.w3.org/2000/svg">
          <g>
            <path
              d="m286 307.953c-8.827 5.108-19.067 8.047-30 8.047-33.137 0-60-26.863-60-60s26.863-60 60-60c10.933 0 21.173 2.939 30 8.047-17.929 10.376-30 29.748-30 51.953s12.071 41.577 30 51.953zm-204 30.088v-164.082c0-55.206 44.644-99.959 99.716-99.959h-60.716c-55.229 0-100 44.771-100 100v164c0 55.228 44.771 100 100 100h60.716c-55.072 0-99.716-44.753-99.716-99.959z"
              fill="#000000" opacity="0.2"/>
            <path
              d="m392 458h-272.021c-66.157 0-119.979-53.823-119.979-119.979v-164.021c0-66.168 53.832-120 120-120h272c66.168 0 120 53.832 120 120v164c0 66.168-53.832 120-120 120zm-272-364c-44.112 0-80 35.888-80 80v164.021c0 44.1 35.879 79.979 79.979 79.979h272.021c44.112 0 80-35.888 80-80v-164c0-44.112-35.888-80-80-80zm136 242c-44.112 0-80-35.888-80-80s35.888-80 80-80 80 35.888 80 80-35.888 80-80 80zm0-120c-22.056 0-40 17.944-40 40s17.944 40 40 40 40-17.944 40-40-17.944-40-40-40z"
              fill="#FFFFFF"/>
            <path
              d="m413 209c-30.327 0-55-24.673-55-55 0-11.046 8.954-20 20-20s20 8.954 20 20c0 8.271 6.729 15 15 15 11.046 0 20 8.954 20 20s-8.954 20-20 20zm-257-53c0-11.046-8.954-20-20-20s-20 8.954-20 20c0 8.271-6.729 15-15 15-11.046 0-20 8.954-20 20s8.954 20 20 20c30.327 0 55-24.673 55-55zm242 202c0-8.271 6.729-15 15-15 11.046 0 20-8.954 20-20s-8.954-20-20-20c-30.327 0-55 24.673-55 55 0 11.046 8.954 20 20 20s20-8.954 20-20zm-242-2c0-30.327-24.673-55-55-55-11.046 0-20 8.954-20 20s8.954 20 20 20c8.271 0 15 6.729 15 15 0 11.046 8.954 20 20 20s20-8.954 20-20z"
              fill="#ffc107"/>
          </g>
        </svg>
        <span>VEZNE</span>
        <div class="AltMenu Vezne">
          <router-link to="/vezne/tahsilat">Tahsilat</router-link>
          <router-link to="/vezne/odeme">Ödeme</router-link>
          <router-link to="/vezne/abonelik">Abonelik Ödeme</router-link>
          <router-link to="/vezne/banka">Banka Hesapları</router-link>
        </div>
      </a>
      <a v-if="this.$store.getters.Yetki.muhasebe>0"
         :class="$route.matched[0].path=='/muhasebe'?'aktif':''"
         href="#"
         class="IkonMenu">
        <svg id="Layer_1" enable-background="new 0 0 512 512" height="512" viewBox="0 0 512 512" width="512"
             xmlns="http://www.w3.org/2000/svg">
          <g>
            <path
              d="m421 322.658c-8.977 4.681-19.175 7.342-30 7.342-35.898 0-65-29.102-65-65s29.102-65 65-65c10.825 0 21.023 2.661 30 7.342-20.794 10.842-35 32.585-35 57.658s14.206 46.816 35 57.658zm-341 69.383v-272.082c0-55.206 44.644-99.959 99.716-99.959h-60.716c-55.229 0-100 44.771-100 100v272c0 55.228 44.771 100 100 100h60.716c-55.072 0-99.716-44.753-99.716-99.959z"
              fill="#000000" opacity="0.2"/>
            <path
              d="m244 126c0 13.807-11.193 25-25 25s-25-11.193-25-25 11.193-25 25-25 25 11.193 25 25zm232 139c0-46.869-38.131-85-85-85s-85 38.131-85 85 38.131 85 85 85 85-38.131 85-85zm-40 0c0 24.813-20.187 45-45 45s-45-20.187-45-45 20.187-45 45-45 45 20.187 45 45zm-224 247h-92.021c-66.156 0-119.979-53.823-119.979-119.979v-272.042c0-66.156 53.823-119.979 119.979-119.979h184.041c66.178 0 120 53.823 120 119.979 0 11.046-8.954 20-20 20s-20-8.954-20-20c0-44.101-35.878-79.979-79.979-79.979h-184.062c-44.1 0-79.979 35.879-79.979 79.979v272.041c0 44.101 35.879 79.98 79.979 79.98h92.021c11.046 0 20 8.954 20 20s-8.954 20-20 20zm118-386c0 13.807-11.193 25-25 25s-25-11.193-25-25 11.193-25 25-25 25 11.193 25 25zm-172 86c0 13.807-11.193 25-25 25s-25-11.193-25-25 11.193-25 25-25 25 11.193 25 25zm0 86c0 13.807-11.193 25-25 25s-25-11.193-25-25 11.193-25 25-25 25 11.193 25 25zm0 86c0 13.807-11.193 25-25 25s-25-11.193-25-25 11.193-25 25-25 25 11.193 25 25zm86-172c0 13.807-11.193 25-25 25s-25-11.193-25-25 11.193-25 25-25 25 11.193 25 25zm0 86c0 13.807-11.193 25-25 25s-25-11.193-25-25 11.193-25 25-25 25 11.193 25 25zm0 86c0 13.807-11.193 25-25 25s-25-11.193-25-25 11.193-25 25-25 25 11.193 25 25z"
              fill="#FFFFFF"/>
            <path
              d="m492 512c-11.046 0-20-8.954-20-20 0-39.701-32.086-72-71.525-72h-16.949c-39.44 0-71.526 32.299-71.526 72 0 11.046-8.954 20-20 20s-20-8.954-20-20c0-61.757 50.03-112 111.525-112h16.949c61.496 0 111.526 50.243 111.526 112 0 11.046-8.954 20-20 20zm-359-411c-13.807 0-25 11.193-25 25s11.193 25 25 25 25-11.193 25-25-11.193-25-25-25z"
              fill="#ffc107"/>
          </g>
        </svg>
        <span>MUHASEBE</span>
        <div class="AltMenu Muhasebe">
          <router-link to="/muhasebe/tahakkuk">Mesken Borçlandır</router-link>
          <router-link to="/muhasebe/gider">Gider İşle</router-link>
          <router-link to="/muhasebe/gelir">Gelir İşle</router-link>
          <router-link to="/muhasebe/cari">Cari</router-link>
          <router-link to="/muhasebe/personel">Personel</router-link>
          <router-link to="/muhasebe/fatura">Şirket Fatura</router-link>
          <router-link to="/muhasebe/kasa">Kasa</router-link>
          <router-link to="/muhasebe/kategori">Kategori</router-link>
          <router-link to="/muhasebe/meskenturu">Mesken Türü</router-link>
        </div>
      </a>
      <a v-if="this.$store.getters.Yetki.raporlama>0"
         :class="$route.matched[0].path=='/raporlama'?'aktif':''" href="#"
         class="IkonMenu">
        <svg id="Layer_1" enable-background="new 0 0 512 512" height="512" viewBox="0 0 512 512" width="512"
             xmlns="http://www.w3.org/2000/svg">
          <g>
            <g>
              <path
                d="m124 392.041v-272.082c0-55.206 44.644-99.959 99.716-99.959h-60.716c-55.229 0-100 44.771-100 100v272c0 55.228 44.771 100 100 100h60.716c-55.072 0-99.716-44.753-99.716-99.959z"
                fill="#000000" opacity="0.2"/>
            </g>
            <g>
              <circle cx="187" cy="210" fill="#FFFFFF" r="25"/>
            </g>
            <g>
              <path
                d="m348.021 512h-184.042c-66.157 0-119.979-53.822-119.979-119.979v-272.042c0-66.157 53.822-119.979 119.979-119.979h184.041c66.158 0 119.98 53.822 119.98 119.979v272.041c0 66.158-53.822 119.98-119.979 119.98zm-184.042-472c-44.1 0-79.979 35.879-79.979 79.979v272.041c0 44.101 35.879 79.98 79.979 79.98h184.041c44.101 0 79.98-35.879 79.98-79.979v-272.042c0-44.1-35.879-79.979-79.979-79.979z"
                fill="#FFFFFF"/>
            </g>
            <g>
              <path
                d="m367 204h-34c-38.598 0-70-31.402-70-70v-34c0-11.046 8.954-20 20-20s20 8.954 20 20v34c0 16.542 13.458 30 30 30h34c11.046 0 20 8.954 20 20s-8.954 20-20 20z"
                fill="#ffc107"/>
            </g>
            <g>
              <path
                d="m317 395h-138c-11.046 0-20-8.954-20-20s8.954-20 20-20h138c11.046 0 20 8.954 20 20s-8.954 20-20 20z"
                fill="#ffc107"/>
            </g>
            <g>
              <path
                d="m317 318h-138c-11.046 0-20-8.954-20-20s8.954-20 20-20h138c11.046 0 20 8.954 20 20s-8.954 20-20 20z"
                fill="#FFFFFF"/>
            </g>
          </g>
        </svg>
        <span>RAPOR</span>
        <div class="AltMenu Raporlama">
          <router-link to="/raporlama/alacak">Alacak Listesi</router-link>
          <router-link to="/raporlama/borc">Borç Listesi</router-link>
          <router-link to="/raporlama/kisi">Kişi Ekstresi</router-link>
          <router-link to="/raporlama/cari">Cari Ekstresi</router-link>
          <div class="AltAlt">
            <span>Kasa Raporu</span>
            <router-link to="/raporlama/kasa/gelir">Kasa Gelir Raporu</router-link>
            <router-link to="/raporlama/kasa/gider">Kasa Gider Raporu</router-link>
            <router-link to="/raporlama/kasa/ekstre">Kasa Ekstresi</router-link>
            <router-link to="/raporlama/kasa/bilanco">Kasa Bilanço</router-link>
            <router-link to="/raporlama/kasa/aylik">Aylık Bilanço</router-link>
          </div>
          <div class="AltAlt">
            <span>Özel Raporlar</span>
            <router-link to="/raporlama/ozel/defter">İşletme Defteri</router-link>
            <router-link to="/raporlama/ozel/gunsonu">Gün Sonu</router-link>
            <router-link to="/raporlama/ozel/hazirun">Hazirun Cetveli</router-link>
            <router-link to="/raporlama/ozel/kisi">Kişi Listesi</router-link>
            <router-link to="/raporlama/ozel/makbuz">Makbuz Arama</router-link>
          </div>
          <div class="AltAlt">
            <span>İcra Raporu</span>
            <router-link to="/raporlama/icra/dosya">İcra Dosya</router-link>
            <router-link to="/raporlama/icra/gecikmis">Gecikmiş Alacaklar</router-link>
          </div>
          <router-link to="/raporlama/sayac">Sayaç Raporu</router-link>
          <router-link to="/raporlama/banka">Banka Ekstresi</router-link>
          <router-link to="/raporlama/webpos">Web Pos Raporu</router-link>
          <router-link to="/raporlama/santral">Santral Raporu</router-link>
        </div>
      </a>
      <a v-if="this.$store.getters.Yetki.icra>0" :class="$route.matched[0].path=='/icra'?'aktif':''"
         href="#"
         class="IkonMenu">
        <svg id="Layer_1" enable-background="new 0 0 512 512" height="512" viewBox="0 0 512 512" width="512"
             xmlns="http://www.w3.org/2000/svg">
          <g>
            <path
              d="m179.716 492h-60.716c-55.229 0-100-44.772-100-100v-272c0-55.229 44.771-100 100-100h60.716c-55.072 0-99.716 44.753-99.716 99.959v272.083c0 55.205 44.644 99.958 99.716 99.958zm144.284-115c0-51.123 33.362-94.446 79.5-109.407-11.182-3.625-23.11-5.593-35.5-5.593-63.513 0-115 51.487-115 115s51.487 115 115 115c12.39 0 24.318-1.968 35.5-5.593-46.138-14.961-79.5-58.284-79.5-109.407z"
              fill="#000000" opacity="0.2"/>
            <path
              d="m217 512h-97c-66.168 0-120-53.832-120-120v-272c0-66.168 53.832-120 120-120h184c66.168 0 120 53.832 120 120v65c0 11.046-8.954 20-20 20s-20-8.954-20-20v-65c0-44.112-35.888-80-80-80h-184c-44.112 0-80 35.888-80 80v272c0 44.112 35.888 80 80 80h97c11.046 0 20 8.954 20 20s-8.954 20-20 20zm103-414c0-11.046-8.954-20-20-20s-20 8.954-20 20c0 16.542-13.458 30-30 30h-76c-16.542 0-30-13.458-30-30 0-11.046-8.954-20-20-20s-20 8.954-20 20c0 38.598 31.402 70 70 70h76c38.598 0 70-31.402 70-70zm192 279c0-74.439-60.561-135-135-135s-135 60.561-135 135 60.561 135 135 135 135-60.561 135-135zm-40 0c0 52.383-42.617 95-95 95s-95-42.617-95-95 42.617-95 95-95 95 42.617 95 95z"
              fill="#ffffff"/>
            <path
              d="m410.987 397h-33.987c-11.046 0-20-8.954-20-20v-41c0-11.046 8.954-20 20-20s20 8.954 20 20v21h13.987c11.046 0 20 8.954 20 20s-8.954 20-20 20z"
              fill="#ffc107"/>
          </g>
        </svg>
        <span>İCRA</span>
        <div class="AltMenu Icra">
          <router-link to="/icra/avukat">Avukatlar</router-link>
          <router-link to="/icra/dosya">Dosyalar</router-link>
        </div>
      </a>
      <a v-if="this.$store.getters.Yetki.iletisim>0"
         :class="$route.matched[0].path=='/iletisim'?'aktif':''"
         href="#"
         class="IkonMenu">
        <svg id="Layer_1" enable-background="new 0 0 512 512" height="512" viewBox="0 0 512 512" width="512"
             xmlns="http://www.w3.org/2000/svg">
          <g>
            <path
              d="m415 227.984c-9.217 2.616-18.945 4.016-29 4.016-58.542 0-106-47.458-106-106s47.458-106 106-106c10.055 0 19.783 1.4 29 4.016-44.445 12.614-77 53.497-77 101.984s32.555 89.37 77 101.984zm-335 164.016v-169c0-55.229 44.771-100 100-100h-60c-55.229 0-100 44.771-100 100v169c0 55.228 44.771 100 100 100h60c-55.229 0-100-44.772-100-100z"
              fill="#000000" opacity="0.2"/>
            <path
              d="m392 512h-272c-66.168 0-120-53.832-120-120v-169c0-66.168 53.832-120 120-120h80c11.046 0 20 8.954 20 20s-8.954 20-20 20h-80c-44.112 0-80 35.888-80 80v169c0 44.112 35.888 80 80 80h272c44.112 0 80-35.888 80-80v-115c0-11.046 8.954-20 20-20s20 8.954 20 20v115c0 66.168-53.832 120-120 120zm120-386c0-69.477-56.523-126-126-126s-126 56.523-126 126 56.523 126 126 126 126-56.523 126-126zm-40 0c0 47.42-38.58 86-86 86s-86-38.58-86-86 38.58-86 86-86 86 38.58 86 86z"
              fill="#FFFFFF"/>
            <path
              d="m255.993 371.923c-25.675 0-51.346-8.17-72.767-24.508l-95.332-72.495c-8.792-6.686-10.5-19.234-3.814-28.026 6.687-8.793 19.234-10.501 28.026-3.814l95.355 72.512c28.588 21.805 68.49 21.804 97.055.018l33.333-25.496c8.774-6.71 21.327-5.038 28.037 3.735 6.711 8.773 5.039 21.326-3.735 28.036l-33.355 25.512c-21.438 16.352-47.122 24.526-72.803 24.526zm150.007-214.923v-62c0-11.046-8.954-20-20-20h-20c-11.046 0-20 8.954-20 20s8.954 20 20 20v42c0 11.046 8.954 20 20 20s20-8.954 20-20z"
              fill="#ffc107"/>
          </g>
        </svg>
        <span>İLETİŞİM</span>
        <div class="AltMenu Iletisim">
          <router-link to="/iletisim/sms">Kısa Mesaj</router-link>
          <router-link to="/iletisim/duyuru">Duyuru</router-link>
        </div>
      </a>
      <a v-if="this.$store.getters.Yetki.iptal>0" :class="$route.matched[0].path=='/iptal'?'aktif':''"
         href="#"
         class="IkonMenu">
        <svg id="Layer_1" enable-background="new 0 0 512 512" height="512" viewBox="0 0 512 512" width="512"
             xmlns="http://www.w3.org/2000/svg">
          <g>
            <path
              d="m415.762 462.238-14.238 14.238-70.109-70.109c-17.403-17.403-29.264-39.569-34.088-63.703l-11.327-56.664 56.664 11.326c1.911.382 3.805.824 5.69 1.294l14.972 81.567c4.824 24.135 16.685 46.3 34.088 63.704zm-335.762-70.238v-272c0-55.229 44.771-100 100-100l211.95-.779.05-.221-272 1c-55.229 0-100 44.771-100 100v272c0 55.228 44.771 100 100 100l52.058-.314c-51.515-4.048-92.058-47.131-92.058-99.686z"
              fill="#000000" opacity="0.2"/>
            <path
              d="m310 512h-190c-66.168 0-120-53.832-120-120v-272c0-66.168 53.832-120 120-120h272c66.168 0 120 53.832 120 120v191.5c0 11.046-8.954 20-20 20s-20-8.954-20-20v-191.5c0-44.112-35.888-80-80-80h-272c-44.112 0-80 35.888-80 80v272c0 44.112 35.888 80 80 80h190c11.046 0 20 8.954 20 20s-8.954 20-20 20zm180.619-21.382c28.462-28.462 28.462-74.774 0-103.237l-70.109-70.108c-20.263-20.264-45.827-33.942-73.926-39.559l-56.664-11.326c-6.554-1.313-13.334.742-18.062 5.47-4.728 4.729-6.78 11.506-5.47 18.063l11.326 56.664c5.617 28.1 19.296 53.662 39.558 73.926l70.109 70.108c13.788 13.787 32.12 21.381 51.619 21.381s37.831-7.594 51.619-21.382zm-151.875-173.68c20.329 4.063 38.822 13.958 53.481 28.618l70.109 70.108c12.867 12.867 12.867 33.803 0 46.67-6.232 6.233-14.52 9.666-23.334 9.666s-17.102-3.433-23.334-9.666l-70.109-70.108c-14.659-14.66-24.555-33.153-28.618-53.481l-5.447-27.253z"
              fill="#FFFFFF"/>
            <path
              d="m392 146h-183c-11.046 0-20-8.954-20-20s8.954-20 20-20h183c11.046 0 20 8.954 20 20s-8.954 20-20 20zm20 60c0-11.046-8.954-20-20-20h-272c-11.046 0-20 8.954-20 20s8.954 20 20 20h272c11.046 0 20-8.954 20-20zm-200 80c0-11.046-8.954-20-20-20h-72c-11.046 0-20 8.954-20 20s8.954 20 20 20h72c11.046 0 20-8.954 20-20zm-112-162c0 13.807 11.193 25 25 25s25-11.193 25-25-11.193-25-25-25-25 11.193-25 25z"
              fill="#ffc107"/>
          </g>
        </svg>
        <span>İPTAL</span>
        <div class="AltMenu Iptal">
          <router-link to="/iptal/tahakkuk">Mesken Borç İşlem</router-link>
          <router-link to="/iptal/sayac">Sayaç İşlem</router-link>
          <router-link to="/iptal/gider">Gider İşlem</router-link>
          <router-link to="/iptal/gelir">Gelir İşlem</router-link>
          <router-link to="/iptal/makbuz">Makbuz İşlem</router-link>
        </div>
      </a>
    </div>
  </div>
</template>
<script>

export default {
  data() {
    return {
      aienerji: false,
    }
  },
  created() {
    if (localStorage.getItem('_aienerji')) {
      this.aienerji = true;
      // if (!old) window.location.reload();
    }
  }
}
</script>

<style>
.el-menu-vertical-demo:not(.el-menu--collapse) {
  width: 200px;
  min-height: 400px;
}
</style>



// WEBPACK FOOTER //
// src/components/Doc/Menu/SirketMenu.vue